export const campaignChannels = {
  emails: 'emails',
  whatsapp: 'whatsapp',
  telegram: 'telegram',
  voice: 'voice',
} as const;
